import React from 'react'
import styled from 'styled-components'
import { formatGpDisplay } from 'src/utils/recipeGp'

const RecipeGpBadge = ({ grossProfit }) => {
  const { band, valueText } = formatGpDisplay(grossProfit)

  return (
    <Badge
      $backgroundColor={band.backgroundColor}
      $color={band.color}
      title={band.label}
    >
      {valueText}
    </Badge>
  )
}

const Badge = styled.span`
  display: inline-block;
  margin-left: 10px;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`

export default RecipeGpBadge
